import type { ApexOptions } from 'apexcharts'
import type { ChartSeriesItem } from '../types/chart.types'
import { ChartStyleColors } from './chart-colors'
import { localeNumberFormatter } from './chart-formatters'
import { buildBarChartOptions } from './bar-chart.config'

export interface GroupedBarChartConfig {
  categories: string[]
  series: ChartSeriesItem[]
  valueFormatter?: (v: number) => string
}

export const buildGroupedBarChartOptions = (config: GroupedBarChartConfig): ApexOptions => {
  const { categories, series, valueFormatter = localeNumberFormatter } = config

  const options = buildBarChartOptions({
    series,
    categories,
    stacked: false,
    columnWidth: '60%',
    yAxisFormatter: valueFormatter,
    tooltipValueFormatter: valueFormatter,
    // Categories are plain labels (e.g. section names), not month strings
    xAxisLabelFormatter: (value) => value
  })

  return {
    ...options,
    legend: {
      show: true,
      position: 'top',
      horizontalAlign: 'left',
      fontSize: '12px',
      labels: { colors: ChartStyleColors.labelColor },
      markers: { size: 5, shape: 'square' as const },
      itemMargin: { horizontal: 8 }
    }
  }
}
